import { render, staticRenderFns } from "./PageLogout.vue?vue&type=template&id=d7116d52&scoped=true&"
import script from "./PageLogout.vue?vue&type=script&lang=js&"
export * from "./PageLogout.vue?vue&type=script&lang=js&"
import style0 from "./PageLogout.vue?vue&type=style&index=0&id=d7116d52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7116d52",
  null
  
)

export default component.exports